import React, { useEffect, useState } from "react";
import { NavLink as ReactLink, useNavigate } from "react-router-dom";
import { Navbar, NavbarBrand, Nav, NavItem } from "react-bootstrap";
import { logoutEmployee } from "../services/EmployeeService";
import "../css/AdminNavbar.css"; // Reuse existing styles
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const EmployeeNavbar = () => {
  const navigate = useNavigate();

  const [employee, setEmployee] = useState({});
  const [imageSrc, setImageSrc] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);

  const togglePopup = () => setPopupOpen(!isPopupOpen);

  useEffect(() => {
    const emp = localStorage.getItem("employee");
    if (emp) {
      const parsed = JSON.parse(emp);
      setEmployee(parsed);

      const trimmedBase64 = parsed.image?.trim();
      if (trimmedBase64) {
        setImageSrc(`data:image/jpeg;base64,${trimmedBase64}`);
      }
    }
  }, []);

  const logout = () => {
    logoutEmployee();
    navigate("/");
  };

  return (
    <div>
      <Navbar className="navbar" expand="lg">
        <NavbarBrand style={{ paddingLeft: "20px" }}>
          <ReactLink to="/employee/dashboard">
            <img
              className="navbar_logo_image"
              src="/logo192.png"
              alt="logo"
            />
          </ReactLink>
        </NavbarBrand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          style={{ marginRight: "20px" }}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              as={ReactLink}
              to="/employee/dashboard"
              className="navname"
            >
              Dashboard
            </Nav.Link>
            <Nav.Link className="navname" onClick={() => toast("Coming soon")}>
              Help Center
            </Nav.Link>
          </Nav>
          <Nav navbar>
            <NavItem>
              <div onClick={togglePopup} className="nav-user-name navbar_link">
                <img
                  src={imageSrc || "./../../../img/avtar.jpg"}
                  alt="avatar"
                />
                {employee.firstName + " " + employee.lastName}
                <FontAwesomeIcon
                  icon={faCaretDown}
                  style={{ marginLeft: "10px" }}
                />
              </div>
            </NavItem>
            {isPopupOpen && (
              <div className="popup1">
                <ul>
                  <ReactLink to="/employee/dashboard" className="navbar_link">
                    Dashboard
                  </ReactLink>
                  <ReactLink to="/employee/profile" className="navbar_link">
                    Profile
                  </ReactLink>
                  <a onClick={logout} className="navbar_link">
                    Logout
                  </a>
                </ul>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default EmployeeNavbar;
